var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.facet.name &&
    ![
      28, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46,
      47, 48, 49, 50, 51, 52, 53,
    ].includes(_vm.facet.id)
    ? _c(
        "div",
        { class: "item-filter__wrapper item-filter__wrapper--" + _vm.facet.id },
        [
          _vm.filterType === "sidebar" || _vm.isMobile
            ? _c("div", [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-white filter-toggle collapsed",
                    attrs: {
                      "data-toggle": "collapse",
                      "data-target": "#filter-collapse_" + _vm.facet.id,
                      "aria-expanded": "false",
                      "aria-controls": "filter-collapse_" + _vm._uid,
                    },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.facetName) +
                        "\n            "
                    ),
                    _c("span", [
                      _vm.activeFacets.length > 3
                        ? _c(
                            "span",
                            { staticClass: "badge badge-light badge-pill" },
                            [
                              _vm._v(
                                "\n                    ...\n                "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("i", { staticClass: "fa fa-angle-up ml-2" }),
                    ]),
                  ]
                ),
              ])
            : _c(
                "button",
                {
                  staticClass: "btn btn-outline-dark dropdown-toggle",
                  attrs: {
                    type: "button",
                    id: "dropdownMenuButton",
                    "data-toggle": "dropdown",
                    "aria-haspopup": "true",
                    "aria-expanded": "false",
                  },
                },
                [_vm._v("\n        " + _vm._s(_vm.facetName) + "\n    ")]
              ),
          _vm._v(" "),
          _c(
            "div",
            {
              class: _vm.wrapperClasses,
              attrs: { id: "filter-collapse_" + _vm.facet.id },
            },
            [
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.activeFacets && _vm.activeFacets.length > 0,
                      expression: "activeFacets && activeFacets.length > 0",
                    },
                  ],
                  staticClass: "item-filter__reset",
                  on: {
                    click: function ($event) {
                      return _vm.clearFacet()
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "24",
                        height: "15",
                      },
                    },
                    [
                      _c("use", {
                        attrs: {
                          "xmlns:xlink": "http://www.w3.org/1999/xlink",
                          "xlink:href": "#svg-reset",
                        },
                      }),
                    ]
                  ),
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.$translate(
                          "OD3dprimaV2::Template.categoryResetFilter"
                        )
                      ) +
                      "\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.facet.type === "price"
                ? [_c("item-filter-price")]
                : [
                    _vm.facets.length > 8 &&
                    !_vm.notSearchFacetIds.includes(_vm.facet.id)
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.searchString,
                              expression: "searchString",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            placeholder: _vm.$translate(
                              "OD3dprimaV2::Template.itemSearchSearchTerm"
                            ),
                          },
                          domProps: { value: _vm.searchString },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.searchString = $event.target.value
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "item-filter__scroll",
                        class:
                          _vm.facets.length > 8 &&
                          !_vm.notSearchFacetIds.includes(_vm.facet.id)
                            ? "item-filter__scroll--lg-max-height"
                            : "",
                      },
                      _vm._l(_vm.displayFacets, function (value) {
                        return _c(
                          "div",
                          {
                            key: value.id,
                            staticClass:
                              "item-filter__item custom-control custom-checkbox",
                            class: value.cssClass,
                          },
                          [
                            _vm.colorFacetIds.includes(_vm.facet.id)
                              ? _c(
                                  "label",
                                  {
                                    staticClass:
                                      "item-filter__item-color-label",
                                    class: {
                                      "item-filter--active": _vm.isSelected(
                                        value.id
                                      ),
                                    },
                                    attrs: { for: "option-" + value.id },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "item-filter__item-color",
                                      },
                                      [
                                        _c("div", {
                                          directives: [
                                            {
                                              name: "tooltip",
                                              rawName: "v-tooltip",
                                            },
                                          ],
                                          staticClass:
                                            "item-filter__item-color--inner",
                                          class:
                                            "item-filter__item-color--" +
                                            value.cssClass,
                                          attrs: {
                                            "data-toggle": "tooltip",
                                            "data-placement": "top",
                                            title: value.name,
                                          },
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      attrs: {
                                        type: "checkbox",
                                        id: "option-" + value.id,
                                        disabled: _vm.isLoading,
                                      },
                                      domProps: {
                                        checked: _vm.isSelected(value.id),
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.updateFacet(value)
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", {
                                      staticClass:
                                        "item-filter__item-checkmark d-none",
                                    }),
                                  ]
                                )
                              : [
                                  _c("input", {
                                    staticClass:
                                      "custom-control-input item-filter__checkbox",
                                    attrs: {
                                      id: "option-" + value.id,
                                      type: "checkbox",
                                      disabled:
                                        _vm.isLoading || value.count <= 0,
                                    },
                                    domProps: {
                                      checked: _vm.isSelected(value.id),
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.updateFacet(value)
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "item-filter__label custom-control-label",
                                      class: [
                                        _vm.paddingClasses,
                                        _vm.isSelected(value.id)
                                          ? "item-filter__label--active"
                                          : "",
                                      ],
                                      attrs: { for: "option-" + value.id },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(value.name) +
                                          "\n                        "
                                      ),
                                    ]
                                  ),
                                ],
                          ],
                          2
                        )
                      }),
                      0
                    ),
                  ],
            ],
            2
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }